import { render, staticRenderFns } from "./ProccesRequest.vue?vue&type=template&id=5b65da3e&"
import script from "./ProccesRequest.vue?vue&type=script&lang=js&"
export * from "./ProccesRequest.vue?vue&type=script&lang=js&"
import style0 from "./ProccesRequest.vue?vue&type=style&index=0&id=5b65da3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports